import { assetUrl } from "fusion-core";

export const INSURERS = [
  {
    key: "AXA",
    schemeTableIds: [1762],
    displayName: "AXA Insurance Company Limited",
    information:
      "AXA Insurance Company Limited is registered under company number 078950 with its registered office at 20 Gracechurch Street, London, EC3V 0BG. AXA Insurance Company Limited are authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and Prudential Regulation Authority under Financial Services Register number 202312.",
    imageUrl: assetUrl("../assets/images/policy-logos/axa.svg"),
  },
  {
    key: "QBE",
    schemeTableIds: [1769],
    displayName: "QBE UK Limited",
    information:
      "This insurance is QBE UK Limited, registered in England & Wales, company no. 01761561. Authorised by the Prudential Regulation Authority (PRA) and regulated by the FCA and the PRA. Firm Reference No. 202842.",
    imageUrl: assetUrl("../assets/images/policy-logos/QBE.png"),
  },
  {
    key: "SABRE",
    schemeTableIds: [1729, 1763, 1765],
    displayName: "Sabre Insurance Company Limited",
    information:
      "Sabre Insurance Company Limited is registered under company number 2387080 with its registered office at Sabre House, 150 South Street, Dorking, Surrey, RH4 2YY. Sabre Insurance Company Limited are authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and Prudential Regulation Authority.",
    imageUrl: assetUrl("../assets/images/policy-logos/Sabre.svg"),
  },
  {
    key: "INSHUR",
    schemeTableIds: [1770],
    displayName: "Inshur UK Limited",
    information:
      "This policy is sold and administered by Inshur UK Limited. Inshur UK Limited is authorised and regulated by the Financial Conduct Authority (FCA) under firm reference number 916800 to carry on insurance distribution activities. Inshur UK Ltd is registered in England and Wales company number 10830222. Registered office at 2nd Floor, 1 Jubilee Street, Brighton, BN1 1GE. This policy is underwritten by Wakam UK Limited which is a company registered in England and Wales with company number 14778827, having its registered office at 18th & 19th Floors 100 Bishopsgate, London, United Kingdom, EC2N 4AG. Authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority under Firm Reference Number 995565.",
    imageUrl: assetUrl("../assets/images/policy-logos/InshurLogo.svg"),
  },
  {
    key: "ERS",
    schemeTableIds: [1759],
    displayName: "ERS",
    information:
      "This insurance is underwritten by ERS (Syndicate 218 at Lloyd’s) which is registered in the UK. IQUW Syndicate Management Limited is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and Prudential Regulation Authority. Registered number: 204851.",
    imageUrl: assetUrl("../assets/images/policy-logos/ERS.svg"),
  },
  {
    key: "CUSTOS",
    schemeTableIds: [1771],
    displayName: "Scor UK Company Limited",
    information:
      "This insurer is Scor UK Company Limited, registered in England & Wales, company no. 01334736. Authorised by the Prudential Regulation Authority (PRA) and regulated by the FCA and the PRA. Firm Reference No. 202333.",
    imageUrl: assetUrl("../assets/images/policy-logos/FreewayLogoDark.png"),
  },
  {
    key: "KGM",
    schemeTableIds: [1764, 1766],
    displayName: "KGM Underwriting Services Limited",
    information:
      "KGM Motor is a brand name for business written by KGM Underwriting Services Limited. KGM Underwriting Services Limited is authorised and regulated by the Financial Conduct Authority, FCA Firm Reference Number 799643. Registered in England & Wales, No: 10581020. Registered Office: 2nd Floor St James House, 27-43 Eastern Road, Romford, Essex, RM1 3NH.",
    imageUrl: assetUrl("../assets/images/policy-logos/kgm.png"),
  },
];

export const INSURER_BY_SCHEME_TABLE_ID = INSURERS.reduce((acc, insurer) => {
  insurer.schemeTableIds.forEach((schemeTableId) => {
    acc[schemeTableId] = insurer;
  });

  return acc;
}, {});

export const SCHEME_IMAGES = INSURERS.reduce((acc, insurer) => {
  insurer.schemeTableIds.forEach((schemeTableId) => {
    acc[schemeTableId] = insurer.imageUrl;
  });

  return acc;
}, {});

export function getInsurerDetailsBySchemeTableId(schemeTableId) {
  return INSURER_BY_SCHEME_TABLE_ID[schemeTableId] ?? null;
}
